module.exports = __webpack_public_path__ + "media/correct.626b88ae.mp3";